const cookies = () => {
    const cookiePopup = document.querySelector('[data-cookies="cookies"]');
    const acceptBtn = document.querySelectorAll('[data-cookies="accept"]');

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split("; ");
        for (let i = 0; i < ca.length; i++) {
            if (ca[i].indexOf(nameEQ) === 0) {
                return ca[i].substring(nameEQ.length);
            }
        }
        return null;
    }

    if (!getCookie("cookiesAccepted")) {
        cookiePopup.classList.add('is-show');
    }

    acceptBtn.forEach(item => {
        item.addEventListener("click", function () {
            setCookie("cookiesAccepted", "true", 365); // Запоминаем на 1 год
            cookiePopup.classList.remove('is-show');;
        });
    });
};

export default cookies;

